export default "__VITE_ASSET__57cfa4a3__"